module.exports = __webpack_public_path__ + "img/condition.c0591004.svg";